import {
  HalfYearExtensionReason,
  YesOrNoFlug,
} from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";
import {
  ChildcareLeaveInfoList,
  IJob_32Props,
  ChildcareActiveListList,
} from "../../../type/contextType/businessContext/IJob_32";
import { changeAmountFormat } from "../../../utils/useTools";

function funInfoBodyList(res?: ChildcareLeaveInfoList[]) {
  const infoBodyList: any = res?.map((item) => [
    {
      children: item.childcareLeaveSerialNo, // 育休連番
    },
    {
      children: item.birthday, // 出生年月日
      align: "center",
    },
    {
      children: item.startDate, // 取得開始日
      align: "center",
    },
    {
      children: item.endDate, // 取得終了日
      align: "center",
    },
    {
      children: TkGetCode(YesOrNoFlug, item.papaMamaFlg), // パパ・ママ育休プラス有無
      align: "center",
    },
    {
      children: TkGetCode(
        HalfYearExtensionReason,
        item.halfyearExtensionReason
      ), // 育休半年延長の理由
    },
    {
      children: TkGetCode(YesOrNoFlug, item.papaChildcareLeaveFlg), // 産後パパ育休
      align: "center",
    },
  ]);

  return infoBodyList;
}

function funWorkingDayNumInfoBodyList(res?: ChildcareActiveListList[]) {
  const infoBody: any = res?.map((item: ChildcareActiveListList) => [
    {
      children: `${(item.yearMonth + "").slice(0, 4)}/${(
        item.yearMonth + ""
      ).slice(4)}`,
      align: "center",
    },
    {
      children: `${item.workingDayNum?.toString()}日`, // 出勤日数
      align: "right",
    },
  ]);

  return infoBody;
}

function funInfoBodyTwoList(res?: IJob_32Props) {
  const bodyList: any = res?.sixMonthsSalaryBeforeApplyList?.map((item) => {
    let allowances = res?.sixMonthsSalaryBeforeApplyDetailList
      ?.filter((i) => i.yearMonth === item.yearMonth)
      ?.map(
        (item) =>
          res.salaryAdjustmentAllowanceList?.find(
            (i) => i.allowanceHisSerialNo === item.allowanceHisSerialNo
          )?.allowanceName
      );

    return [
      {
        children: `${item.yearMonth?.toString()?.slice(0, 4)}年${item.yearMonth
          ?.toString()
          ?.slice(4, 6)}月`,
        align: "center",
      },
      {
        children: `${changeAmountFormat(item.salaryTableAmt ?? 0)}円`, //  俸給表の額
        align: "right",
      },
      {
        children: allowances?.join("、"),
      },
      {
        children: `${changeAmountFormat(item.salaryAdjustmentAmt ?? 0)}円`, //  俸給の調整額
        align: "right",
      },
    ];
  });

  return bodyList;
}

export { funInfoBodyList, funInfoBodyTwoList, funWorkingDayNumInfoBodyList };
